import React, { PureComponent, PropTypes } from 'react';
import { dateFormats } from '../../util/constants';
import NativeTimeSelect from './NativeTimeSelect';
import DatePicker from './DatePicker';
import cx from 'classnames';
import { toDateTime, toTimestamp } from '../../util/DateUtil';
import RequiredIndicator from '../layout/RequiredIndicator';

/**
 * Renders a set of inputs that represent a scheduled and a duration
 */
export default class DateTimeInput extends PureComponent {
  static propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    timezone: PropTypes.string.isRequired,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    inputClassName: PropTypes.string,
    timeSelectProps: PropTypes.object,
    datePickerProps: PropTypes.object
  };

  static defaultProps = {
    value: null,
    required: false,
    timeSelectProps: { minuteInterval: 5 },
    datePickerProps: { displayFormat: dateFormats.DISPLAY_DATE }
  };

  handleDateChange = (date) => {
    const { value, timezone, onChange } = this.props;
    const { time } = toDateTime({ scheduled: value, timezone });

    onChange(
      toTimestamp({
        date,
        time: time || '12:00',
        timezone
      })
    );
  };

  handleTimeChange = time => {
    const { value, timezone, onChange } = this.props;
    const { date } = toDateTime({ scheduled: value, timezone });

    onChange(
      toTimestamp({
        date: date || moment().format(dateFormats.ISO_8601),
        time,
        timezone
      })
    );
  };

  render() {
    const {
      disabled,
      clearable,
      timezone,
      value,
      className,
      required,
      inputClassName,
      timeSelectProps,
      datePickerProps
    } = this.props;
    const { date, time } = toDateTime({ scheduled: value, timezone });

    return (
      <div className={cx('display-flex align-items-center flex-wrap-wrap', className)}>
        <div className="flex-grow-1 mg-right-sm">
          <div>
            <label>Date {required ? <RequiredIndicator /> : null}</label>
          </div>
          <DatePicker {...datePickerProps} inputProps={{ className: inputClassName }} disabled={disabled} value={date}
            onChange={this.handleDateChange} clearable={clearable}/>
        </div>
        <div className="flex-grow-1">
          <div>
            <label>Time {required ? <RequiredIndicator/> : null}</label>
          </div>
          <NativeTimeSelect
            {...timeSelectProps}
            value={time}
            className={inputClassName}
            required={!clearable || required}
            onChange={this.handleTimeChange}
            style={{ minWidth: 100 }}
            disabled={disabled}
            clearable={clearable}/>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/inputs/DateTimeInput.jsx